import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, tap } from 'rxjs/operators';
import { WebSocketService } from '../../server-communication/services/websocket.service';
import { WebSocketMessageType } from '../../../../model/web-socket-message';
import LicenseActions from './license.action-types';

@Injectable()
export class LicenseEffects {
    constructor(private readonly actions$: Actions, private readonly webSocketService: WebSocketService) {}

    activateLicense$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(LicenseActions.activateLicenseRequest),
                tap(licenseRequest => this.webSocketService.sendMessage(WebSocketMessageType.License, licenseRequest))
            ),
        { dispatch: false }
    );
}
